module.exports = __webpack_public_path__ + "static/media/screenshot1.cc07015a.jpg";